import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Indicator from 'components/cards/Indicator'

const PictureIndicators = ({ amount, currentIndex }) => {
  return (
    <Div display="flex" flexDirection="row" justifyContent="center">
      {Array.from(Array(amount)).map((_, i) => (
        <Div key={i} marginLeft={6} marginRight={6}>
          <Indicator isActive={currentIndex === i} />
        </Div>
      ))}
    </Div>
  )
}

PictureIndicators.propTypes = {
  amount: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired
}

export default PictureIndicators



// WEBPACK FOOTER //
// ./src/components/cards/PictureIndicators.js